import { Component } from '../../../../../lib/web/components/component';
import { ComponentBase } from '../../../../../lib/web/components/component-base';
import { QueryString } from '../../../../../lib/web/core/query-string';
import { MediaPlayerService } from '../../../services/media-player.service';

@Component({
    selector: '.p-encoding-preview'
})
export class EncodingPreviewComponent extends ComponentBase<HTMLElement> {

    public constructor(node: HTMLElement, private _mediaPlayerService: MediaPlayerService) {
        super(node);       
    }

    public onInit(): void {
        super.onInit();
        this.openVideo();
    }

    private openVideo(): void {
        this._mediaPlayerService.loadMedia('v2', {
            type: 'video',
            embed: true,
            video: {
                id: QueryString.get().id,
                secret: QueryString.get().secret,
                title: USER_LOCALE.siteName,
            },
            controls: {
                closeOnEnd: false,
                isPreview: true
            }
        });
    }   
}